import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../../Checkout/pages/Shipping/Shipping.module.scss';
import USStateSelector from './USStateDropdown';
import LocaleContext, { FiCountry } from '../../../../contexts/LocaleContext';

interface ChangeHandler {
  onChange(fieldName: string, value: string): void;
}

interface ShippingAddressFields {
  line1?: string;
  line2?: string;
  city?: string;
  zip?: string;
  state?: string;
}

export function ShippingAddressDetails({
  onChange,
  line1,
  line2,
  city,
  zip,
  state,
}: ShippingAddressFields & ChangeHandler) {
  const { t } = useTranslation();
  const { country } = useContext(LocaleContext);
  const isCanada = country === FiCountry.CA;
  return (
    <div className={styles.formSection}>
      <h5 className={styles.small}>{t('shipment_address')}</h5>
      <input
        type="text"
        name="line1"
        placeholder={t('street_address')}
        value={line1}
        onChange={(e) => onChange(e.target.name, e.target.value)}
        autoComplete="address-line1"
        data-hj-whitelist
      />
      <input
        type="text"
        name="line2"
        placeholder={t('apt_suite_other_optional')}
        value={line2}
        onChange={(e) => onChange(e.target.name, e.target.value)}
        autoComplete="address-line-2"
        data-hj-whitelist
      />
      <input
        type="text"
        name="city"
        placeholder={t('city')}
        value={city}
        onChange={(e) => onChange(e.target.name, e.target.value)}
        autoComplete="address-level2"
        data-hj-whitelist
      />
      <div className={styles.formRow}>
        <USStateSelector state={state} onChange={(newState) => onChange('state', newState)} />
        <input
          type="text"
          name="zip"
          placeholder={isCanada ? t('postal_code') : t('zip_code')}
          value={zip}
          onChange={(e) => onChange(e.target.name, e.target.value)}
          autoComplete="postal-code"
          data-hj-whitelist
        />
      </div>
    </div>
  );
}
